import { Component, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { TooltipInfoComponent } from '../tooltip-info/tooltip-info.component';
import { NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'field-type-switch',
  templateUrl: './field-type-switch.component.html',
  standalone: true,
  imports: [FormsModule, NgClass, TooltipInfoComponent]
})
export class FieldTypeSwitchComponent implements OnChanges {
  constructor(private commonUtilsService: CommonUtilsService) { }

  @Input() field: { label?: string, negativeColor?: boolean, description?: any, id?:any};
  @Input() preSelectItem: boolean;
  @Input() disabled:boolean;
  @Input() small: boolean = false;
  @Output() itemSelected = new EventEmitter();

  fieldTypeSwitch: any = {
    id: this.commonUtilsService.createId(),
    checked: false,
    selected: false
  }

  ngOnChanges() {
    if(this.field){
      this.field.id = this.field.id? this.field.id : this.commonUtilsService.createId();
    }
    if (this.fieldTypeSwitch.checked !== this.preSelectItem) {
      this.fieldTypeSwitch.checked = this.preSelectItem;
    }
    if (this.fieldTypeSwitch.selected !== this.preSelectItem) {
      this.fieldTypeSwitch.selected = this.preSelectItem;
    }
  }

  toggleSwitch() {
    if(this.fieldTypeSwitch.checked === this.fieldTypeSwitch.selected){
      this.fieldTypeSwitch.checked = !this.fieldTypeSwitch.checked;
    }
    this.itemSelected.emit({ newValue: this.fieldTypeSwitch.checked, value: this.fieldTypeSwitch.checked });
  }
}
